import { useState, type FormEvent } from 'react';
import simbolo from '@planilla/ui/marca/simbolo.svg';
import { esElegirEntidad } from '../api/cliente';
import { Boton, Campo, Entrada } from '../componentes/Controles';
import { Icono } from '../componentes/Icono';
import { mensajeDeError, Nota } from '../componentes/Piezas';
import { useSesion } from '../sesion/sesion';

/**
 * El ingreso: el logo y dos campos, centrados. Nada de texto que leer antes de entrar
 * (Rodrigo, 2026-09-26: "que sea sencillo").
 */
export function PaginaIngreso() {
  const sesion = useSesion();
  const [identificador, setIdentificador] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  /**
   * Si la persona trabaja en más de una entidad, la API contesta 409 con la lista: recién al
   * validar la clave sabe cuántas son. No es un error, es una pregunta, y se muestra como tal.
   */
  const [entidades, setEntidades] = useState<Array<{ id: string; nombre: string; rol: string }> | null>(null);

  async function ingresar(evento?: FormEvent, entidadId?: string) {
    evento?.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await sesion.ingresar(identificador.trim(), clave, entidadId);
    } catch (e) {
      if (esElegirEntidad(e)) setEntidades(e.detalles.entidades);
      else setError(mensajeDeError(e));
    } finally {
      setEnviando(false);
    }
  }

  const marca = (
    <div className="ingreso__marca">
      <img src={simbolo} alt="" />
      <strong>Planilla</strong>
    </div>
  );

  return (
    <div className="ingreso">
      {entidades ? (
        <div className="ingreso__caja">
          {marca}
          <div>
            <h2>¿Dónde entrás?</h2>
            <p>Tu usuario trabaja en más de una entidad. Cada una tiene su gente y su plata.</p>
          </div>
          <div className="ingreso__entidades">
            {entidades.map((entidad) => (
              <button
                key={entidad.id}
                type="button"
                className="ingreso__entidad"
                onClick={() => void ingresar(undefined, entidad.id)}
                disabled={enviando}
              >
                <Icono nombre="escudo" />
                <div>
                  <strong>{entidad.nombre}</strong>
                  <small>{entidad.rol}</small>
                </div>
                <Icono nombre="derecha" />
              </button>
            ))}
          </div>
          {error ? <Nota tono="error">{error}</Nota> : null}
          <Boton variante="fantasma" icono="izquierda" onClick={() => setEntidades(null)}>
            Volver
          </Boton>
        </div>
      ) : (
        <form className="ingreso__caja" onSubmit={(e) => void ingresar(e)}>
          {marca}
          <div className="formulario">
            <Campo etiqueta="Usuario o correo">
              {(id) => (
                <Entrada
                  id={id}
                  type="text"
                  autoComplete="username"
                  autoCapitalize="none"
                  spellCheck={false}
                  value={identificador}
                  onChange={(e) => setIdentificador(e.target.value)}
                  autoFocus
                  required
                />
              )}
            </Campo>
            <Campo etiqueta="Contraseña">
              {(id) => (
                <Entrada id={id} type="password" autoComplete="current-password" value={clave} onChange={(e) => setClave(e.target.value)} required />
              )}
            </Campo>
          </div>
          {error ? <Nota tono="error">{error}</Nota> : null}
          <Boton type="submit" variante="primario" tamano="grande" cargando={enviando} icono="derecha">
            Entrar
          </Boton>
        </form>
      )}
    </div>
  );
}
